/* istanbul ignore file */
import { Dropdown, DefaultDropdownProps } from 'framework/form';
import { LEAD_MEDIUM } from 'domain/sales/lead/shared/leadService';

const LeadMediumDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return (
    <Dropdown
      placeholder="Choose lead medium"
      options={Object.entries(LEAD_MEDIUM).map(entry => {
        const [value, label] = entry;
        return {
          value,
          label,
        };
      })}
      label="Lead medium"
      {...props}
    />
  );
};

export default LeadMediumDropdown;
